module.exports = __webpack_public_path__ + "static/media/part-15.27a13a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-15.jpg
// module id = 948
// module chunks = 0